import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { inquireArtworkUrl, type InquireArtworkParams } from "../lib/inquireArtwork";

export function InquireArtworkLink({
  medium,
  id,
  name,
  className,
  children,
}: InquireArtworkParams & {
  className?: string;
  children?: React.ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <Link to={inquireArtworkUrl({ medium, id, name })} className={className}>
      {children ?? t("gallery.inquirePiece")}
    </Link>
  );
}
